import { useRef, PropsWithChildren } from 'react';
import { Toast } from 'primereact/toast';
import { ToastContext } from './toast-context';

export const ToastProvider = ({ children }: PropsWithChildren) => {
  const toastRef = useRef<Toast>(null);

  return (
    <ToastContext.Provider value={toastRef}>
      <Toast ref={toastRef} position="bottom-left" />
      {children}
    </ToastContext.Provider>
  );
};
